<template>
    <div class="wgykh">
        <img src="../../assets/images/wgykh.png" alt="">
    </div>
</template>

<script>
    export default {
        name: "Wgykh"
    }
</script>

<style scoped>

</style>
